import { Typography } from "@mui/material";
import React from "react";
import "./offerPriceTypography.scss";
interface OfferPriceTypographyProps {
  currencySymbol: string;
  amount: any;
}

const OfferPriceTypography: React.FC<OfferPriceTypographyProps> = (
  props: any
) => {
  const { currencySymbol, amount } = props;
  if (amount <= 0) {
    return null;
  }
  return (
    <Typography variant="body2" className="offerTextMain">
      {currencySymbol}{amount ? amount : ""}
    </Typography>
  );
};

export default OfferPriceTypography;
